import './ui/styles.css'
import * as THREE from 'three'

const app = document.getElementById('app')
if (!app) throw new Error('missing #app')

const pathname = location.pathname.replace(/\/+$/, '') || '/'

if (pathname === '/admin' || pathname.startsWith('/admin/')) {
  document.documentElement.classList.add('admin-document')
  document.body.classList.add('admin-document')
}
if (pathname === '/feedback') {
  document.documentElement.classList.add('feedback-document')
  document.body.classList.add('feedback-document')
}

if (pathname === '/admin') {
  void import('./ui/AdminConsole').then(({ startAdminConsole }) => startAdminConsole(app)).catch(error => {
    app.textContent = `Admin console failed to start: ${String(error)}`
  })
} else if (pathname === '/admin/world') {
  void import('./ui/WorldGuide').then(({ startWorldGuide }) => startWorldGuide(app)).catch(error => {
    app.textContent = `World guide failed to start: ${String(error)}`
  })
} else if (pathname === '/admin/items' || pathname === '/admin/quests' || pathname === '/admin/mobs') {
  void import('./ui/AdminCatalog').then(({ startAdminCatalog }) => startAdminCatalog(app, pathname === '/admin/items' ? 'items' : pathname === '/admin/quests' ? 'quests' : 'mobs')).catch(error => {
    app.textContent = `Content review failed to start: ${String(error)}`
  })
} else if (pathname === '/admin/professions') {
  void import('./ui/AdminProfessions').then(({ startAdminProfessions }) => startAdminProfessions(app)).catch(error => {
    app.textContent = `Profession review failed to start: ${String(error)}`
  })
} else if (pathname === '/feedback') {
  void import('./ui/FeedbackBoard').then(({ startFeedbackBoard }) => startFeedbackBoard(app)).catch(error => {
    app.textContent = `Feedback board failed to start: ${String(error)}`
  })
} else if (pathname === '/admin/assets' || new URLSearchParams(location.search).has('assets')) {
  void import('./render/AssetViewer').then(({ startAssetViewer }) => startAssetViewer(app)).catch(error => {
    app.textContent = `Asset viewer failed to start: ${String(error)}`
  })
} else if (new URLSearchParams(location.search).has('style')) {
  void import('./ui/StyleReview').then(({ startStyleReview }) => startStyleReview(app)).catch(error => {
    app.textContent = `Style review failed to start: ${String(error)}`
  })
} else if (new URLSearchParams(location.search).has('icons')) {
  void import('./ui/IconReview').then(({ startIconReview }) => startIconReview(app)).catch(error => {
    app.textContent = `Icon review failed to start: ${String(error)}`
  })
} else {
  void import('./ui/requiresDesktop').then(({ needsDesktop, showDesktopGate }) => {
    if (needsDesktop()) {
      showDesktopGate(app)
      return
    }
    return import('./game/Game').then(({ Game }) => {
      const game = new Game(app)
      // The review harnesses drive the game through this handle; __THREE lets one add probe geometry
      // (tools/review/surface-shots.mjs drops a mirror sphere in to check the environment map).
      if (import.meta.env.DEV) Object.assign(window, { __stormhollow: game, __THREE: THREE })
      game.start()
    })
  })
}
